import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('UNREAD_NOTIFICATION').plugin(axiosPlugin);

let fetchUnreadNotificationsAction = redux.fetchActionGetOne();

export const subscribeUnreadNotifications = redux.action('SUBSCRIBE', function () {
    return {
        subscribe: {
            path: 'UNREAD_NOTIFICATION'
        }
    }
});

export const unsubscribeUnreadNotifications = redux.action('UNSUBSCRIBE', function () {
    return {
        unsubscribe: {
            type: redux.types.SUBSCRIBE,
        }
    }
});

redux.reducerForType('SUBSCRIBE_DATA', (state, action) => {
    let newState = {...state};
    newState.data.total = action.payload.total;
    return newState;
});

export const fetchUnreadNotifications = () => fetchUnreadNotificationsAction(`/users/me/notifications/unread`);
export const resetUnreadNotifications = () => redux.actions.reset();

export const userUnreadNotifications = redux.reducer();